// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--VUGIP","container":"Footer-module--container--39nRG","content":"Footer-module--content--3u_Ao","logo":"Footer-module--logo--1eKbS"};